import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { CreditCardType } from '@arc/aureus';

export function cardTypeCVV(creditCardType: CreditCardType): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value == null || control.value === '') {
      return null;
    }

    const validationError = { cvv: true };

    if (isNaN(control.value)) {
      return validationError;
    }

    let cvvLength = 3;

    if (creditCardType === 'american-express') {
      cvvLength = 4;
    }

    if (control.value.length !== cvvLength) {
      return validationError;
    }

    return null;
  };
}
